import React from 'react'
import emailIcon from '../../../shared/assets/email-icon.svg'
import telegramIcon from '../../../shared/assets/telegram-icon.svg'

const LINK_CLASS = 'rounded-[6px] p-[12px] shadow-outline shadow-focus/[0.65]'

export const StubContactLinks = () => {
  return (
    <div className={'flex justify-center gap-[12px]'}>
      <a aria-label={'Email'} className={LINK_CLASS} href={'mailto:sales@bluepear.co'}>
        <img alt={''} src={emailIcon} />
      </a>
      <a
        aria-label={'Telegram'}
        className={LINK_CLASS}
        href={'https://t.me/bluepear_team'}
        rel={'noreferrer'}
        target={'_blank'}
      >
        <img alt={''} src={telegramIcon} />
      </a>
    </div>
  )
}
